module.exports = __webpack_public_path__ + "static/takenotes-7ac92f9e4c5bc70a2e10e06d1799f70b.png";